import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const changeSourceOrganization = createAsyncThunk(
  "users/changeSourceOrganization",
  async (sourceOrganizationId : any, { rejectWithValue, getState }) => {
    
    const state = getState() as RootState;

    try {
      if(sourceOrganizationId != state.userAuthentication.user?.sourceOrganization){
        await axiosInstance.post(`${api.baseURL}user/set-source-organization`, {
          userId: state.userAuthentication.user?.id,
          sourceOrganization: sourceOrganizationId*1
        },
      );
      }
      return Response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
